import React from "react";

import { FormContext } from "src/features/forms/context/FormContext";
import { useLogMap } from "src/features/forms/hooks/useLogMap";
import { LogMap } from "src/features/forms/types";

export const LogContext = React.createContext<{
	messages: LogMap;
	warnings: LogMap;
	errors: LogMap;
}>({
	messages: {},
	warnings: {},
	errors: {}
});

export const LogContextProvider: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => {
	const { messages, warnings, errors } = React.useContext(FormContext);

	const messageMap = useLogMap(messages);
	const warningMap = useLogMap(warnings);
	const errorMap = useLogMap(errors);

	const ctx = React.useMemo(
		() => ({
			messages: messageMap,
			warnings: warningMap,
			errors: errorMap
		}),
		[messageMap, warningMap, errorMap]
	);

	return <LogContext.Provider value={ctx}>{children}</LogContext.Provider>;
};
